import { useNavigate } from "react-router-dom";
import { Landing } from "../components/Landing/Landing";
import { ASSERTION_URL } from "App.const";
import { LANDING_SCREEN_TITLE } from "./Title.const";

export const LandingScreen = () => {
  document.title = LANDING_SCREEN_TITLE;
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(ASSERTION_URL, { replace: true });
  };
  return (
    <>
      <Landing onProgress={handleClick} />
    </>
  );
};
